/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArchiveTemplate } from '../../models/archive-template';

export interface PatientArchiveGetClinicalArchiveTemplates$Params {
}

export function patientArchiveGetClinicalArchiveTemplates(http: HttpClient, rootUrl: string, params?: PatientArchiveGetClinicalArchiveTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<ArchiveTemplate>> {
  const rb = new RequestBuilder(rootUrl, patientArchiveGetClinicalArchiveTemplates.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArchiveTemplate>;
    })
  );
}

patientArchiveGetClinicalArchiveTemplates.PATH = '/api/PatientArchive/patientarchive/archiveClinicalTemplates';
